var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "oa-dialog" },
    [
      _c(
        "el-dialog",
        {
          attrs: {
            top: "10%",
            visible: _vm.show,
            width: "700px",
            "append-to-body": "",
            "show-close": false,
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.show = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "header flex-between",
              attrs: { slot: "title" },
              slot: "title",
            },
            [
              _c("span", { staticClass: "title" }, [_vm._v("视图管理")]),
              _vm._v(" "),
              _c("span", {
                staticClass: "el-icon-close",
                on: { click: _vm.handleClose },
              }),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "flex mb20 flex-between" },
            [
              _c(
                "div",
                [
                  _c("el-input", {
                    staticClass: "input",
                    staticStyle: { width: "300px" },
                    attrs: {
                      "prefix-icon": "el-icon-search",
                      size: "small",
                      placeholder: "请输入视图名称(10个字以内)",
                      clearable: "",
                    },
                    on: { change: _vm.changeList },
                    model: {
                      value: _vm.where.title,
                      callback: function ($$v) {
                        _vm.$set(_vm.where, "title", $$v)
                      },
                      expression: "where.title",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "small" },
                  on: { click: _vm.addViewFn },
                },
                [_vm._v("新建视图")]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.list.length > 0
            ? _c("ul", { staticClass: "content-title" }, [
                _c("li", [
                  _c("p", [_vm._v("顺序")]),
                  _vm._v(" "),
                  _c("p", [_vm._v("视图名称")]),
                  _vm._v(" "),
                  _c("p", [_vm._v("类型")]),
                  _vm._v(" "),
                  _c("p", [_vm._v("操作")]),
                ]),
                _vm._v(" "),
                _c(
                  "ul",
                  { staticClass: "content-body" },
                  [
                    _c(
                      "draggable",
                      {
                        attrs: {
                          "chosen-class": "chosen",
                          "force-fallback": "true",
                          group: "people",
                          animation: "1000",
                        },
                        on: { start: _vm.onStart, end: _vm.onEnd },
                        model: {
                          value: _vm.list,
                          callback: function ($$v) {
                            _vm.list = $$v
                          },
                          expression: "list",
                        },
                      },
                      [
                        _c(
                          "transition-group",
                          _vm._l(_vm.list, function (item, index) {
                            return _c("li", { key: index }, [
                              _c("p", [
                                _c("i", {
                                  staticClass:
                                    "icon iconfont icontuodong item-drag",
                                }),
                              ]),
                              _vm._v(" "),
                              _c("p", { staticClass: "text" }, [
                                _vm._v(_vm._s(item.senior_title)),
                              ]),
                              _vm._v(" "),
                              _c("p", { staticClass: "text" }, [
                                _vm._v(
                                  _vm._s(
                                    item.senior_type == 0 ? "个人" : "公共"
                                  )
                                ),
                              ]),
                              _vm._v(" "),
                              _c("p", [
                                _c("span", {
                                  staticClass: "iconfont iconbianji1 mr10",
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      return _vm.editFn(item)
                                    },
                                  },
                                }),
                                _vm._v(" "),
                                _c("span", {
                                  staticClass: "el-icon-delete",
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      return _vm.delFn(item, index)
                                    },
                                  },
                                }),
                              ]),
                            ])
                          }),
                          0
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.list.length == 0
            ? _c(
                "div",
                [
                  _c("default-page", {
                    attrs: { index: 19, height: "200px", imgWidth: "117px" },
                  }),
                ],
                1
              )
            : _vm._e(),
        ]
      ),
      _vm._v(" "),
      _c("oa-dialog", {
        ref: "oaDialog",
        attrs: {
          fromData: _vm.fromData,
          formConfig: _vm.formConfig,
          formRules: _vm.formRules,
          formDataInit: _vm.formDataInit,
        },
        on: { submit: _vm.submit },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }